import { render, staticRenderFns } from "./PheProjectAdvancedDetails.vue?vue&type=template&id=1511ddf8&"
import script from "./PheProjectAdvancedDetails.vue?vue&type=script&lang=js&"
export * from "./PheProjectAdvancedDetails.vue?vue&type=script&lang=js&"
import style0 from "./PheProjectAdvancedDetails.vue?vue&type=style&index=0&id=1511ddf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports